import { Component, HostListener, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractInputLayoutComponent } from '@shared/components/games/input-layouts/AbstractInputLayout';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { CalculatorContainer } from '@games/core/focus/CalculatorContainer';

@Component({
  selector: 'ms-calculator-layout',
  templateUrl: './calculator-layout.component.html',
  styleUrl: './calculator-layout.component.scss',
  imports: [CommonModule, CalculatorModule],
})
export class CalculatorLayoutComponent extends AbstractInputLayoutComponent {
  readonly standalone = input(false);
  readonly overlay = input(false);

  readonly calculatorContainer = inject(CalculatorContainer, { optional: true });

  readonly isVisible = signal(true);

  @HostListener('click', ['$event'])
  onHostClick(event: MouseEvent): void {
    this.keyboardAdapter.rescueFocus();
  }

  ngOnInit() {
    if (!this.standalone()) {
      if (this.calculatorContainer) {
        this.calculatorContainer.setCalculator({
          hide: () => {
            this.isVisible.set(false);
          },
          show: () => {
            this.isVisible.set(true);
          },
        });
      }
    }
  }

  onKeydown(code: string) {
    this.keyboardAdapter.simulateKeyPress(code);
  }
}
